/**
 *
 * 브라우저 현상:
 * - history stack 생성 전, history.replaceState() 로 state 를 생성할 수 있음.
 *   - 찻 state 를 replace 하지 않은 경우, 첫 시점으로 back 시 onpopstate 가 반환하는 state는 항상 null
 * - JS로 #fragment 경로 이동시 히스토리 생성됨
 * - history stack에 값이 있는 상태에서 다른 페이지로 이동(링크 클릭) 후
 *   - back 을 1회차 했을 때 popstate 호출 안됨. 단 페이지에서 history.state 값을 읽을 수 있음.
 *
 * 요구사항:
 * - 모달을 hardware/software back 키로 닫음
 *
 * 구현되면 좋음:
 * - 다른 페이지로 이동 후 돌아왔을 때 "모달 닫기"용 히스토리 없는 상태
 * - 모달을 중복으로 열어도 히스토리는 1개만 생성
 * - 의미 없는 히스토리가 안 생기면 좋음
 *
 * 알려진 문제:
 * - history stack에 값이 있는 상태에서 다른 페이지로 이동(링크 클릭) 후
 *   - back 을 2회차 했을 때 기존 state 값에 따라 아무동작도 하지 않는 1개 스텝 발생가능
 *     - 조건: state 값이 null 이 아닐 경우
 *
 * 다른 히스토리 메카니즘과 함께 작동할 것을 고려할 것 인지?
 * -
 *
 * 다른 접근
 * - 다른 페이지로 이동했다가 back 으로 다시 돌아왔을 때, onpopstate 를 받지 못함
 *   이 상태 인지를 파악해서 history.back() 을 실행하는 것도 해법인지?
 */


/**
 * backKeyTrapper 특징
 * - parent state 내에서 같은 name 값을 갖는 child state가 생성될 수 없다.
 * - 다른 페이지에서 back 으로 돌아왔을때 최종상태 state에 name이 남아있다면 onPageInit에서 강제로 history.back() 함.
 * - state 데이터구조
 *   @type {{back_key_trapper_names:[]}} {back_key_trapper_names:[name1, name2, name3, ...]}
 */
window.backKeyTrapper = {
    getState               : function () {
        return window.history.state;
    },
    hasName                : function (name) {
        if (typeof this.getState() === 'undefined' || this.getState() === null)
        {
            return false;
        }
        if (!this.getState().hasOwnProperty('back_key_trapper_names'))
        {
            return false;
        }
        return this.getState().back_key_trapper_names.indexOf(name) > -1;
    },
    initNamesDataAndReplace: function () {
        var state = this.getState();
        if (state === null)
        {
            state = {};
        }
        if (!state.hasOwnProperty('back_key_trapper_names'))
        {
            state.back_key_trapper_names = [];
        }
        this.replaceState(state);
    },
    replaceState           : function (data) {
        window.history.replaceState(data, document.title);
    },
    addNameAndReplace      : function (name) {
        this.initNamesDataAndReplace();

        var state = this.getState();
        state.back_key_trapper_names.push(name);
        this.replaceState(state);
    },
    pushState              : function (name) {
        window.history.pushState({back_key_trapper_names: [name]}, document.title);
    },
    popstate               : function (event) {
        var state = event.state;
        // state.back_key_trapper_names 는 "상태 이름"을 갖는 배열
        if (state === null || typeof state !== "object"
            || !state.hasOwnProperty('back_key_trapper_names')
            || !Array.isArray(state.back_key_trapper_names))
        {
            return;
        }

        var should_emit_dismiss_modal = false;
        state.back_key_trapper_names.forEach(function (val, idx) {
            if (val === 'modal') // "modal" 값은 onpopstate 이벤트에서 모달을 닫아야 할 때를 의미
            {
                // 해당 엔트리 삭제
                state.back_key_trapper_names.splice(idx, 1);
                should_emit_dismiss_modal = true;
            }
        });

        if (should_emit_dismiss_modal)
        {
            require(['vue'], function (Vue) {
                if (typeof window.event_bus === 'undefined')
                {
                    window.event_bus = new Vue();
                }

                window.event_bus.$emit('dismiss-modal');
            });
        }
    },
    // onpopstate 이벤트는 못받음
    // history.state 값은 있음
    // -> 다른 페이지에서 back 으로 돌아온 것인지?
    opPageInit: function () {
        if (this.hasName('modal'))
        {
            window.history.back();
        }
    },

    // 모달 표시
    replaceAndPushHistory    : function (name) {
        var a = this.hasName(name);
        if (this.hasName(name))
        {
            return;
        }
        // pop 이벤트에서 모달을 닫을 수 있도록 'modal'을 추가한다. 현재 state에 추가하기 때문에 pushState 전에 호출해야함
        this.addNameAndReplace(name);
        this.pushState(name);
    },
    removeBackKeyTrapperNames: function () {
        if (typeof this.getState() === 'undefined' || this.getState() === null)
        {
            return;
        }
        if (!this.getState().hasOwnProperty('back_key_trapper_names'))
        {
            return;
        }
        delete this.getState().back_key_trapper_names;
    }
};

window.addEventListener("popstate", backKeyTrapper.popstate);
